'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Auth';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import LoginForm from 'Components/Forms/LoginForm';
export default class LoginPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Login"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "login-page__left"
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      className: "home-link"
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "u-margin-right-10"
    }), " Retourner sur le site myWO"), /*#__PURE__*/React.createElement("div", {
      className: "login-page__content"
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        display: 'block',
        width: '240px',
        maxWidth: '100%',
        margin: 0
      }
    }), /*#__PURE__*/React.createElement(LoginForm, null))), /*#__PURE__*/React.createElement("div", {
      className: "login-page__right"
    }));
    return output;
  }
}
